import * as url from "helpers/url_helper";
import { APIClient } from "helpers/api_helper";
import { postImport } from "common/lib/importClient";

const api = new APIClient();

// Mdas
export const getMdas = (params: any) => api.get(url.GET_MDAS, params);
export const getMda = (id: any, params: any) => {
  const populate: any = [];
  if (!params?.populate) params.populate = populate;
  return api.get(url.GET_MDA + "/" + id, params);
};
export const addMda = (data: any) => api.create(url.ADD_MDA, data);
export const importMdas = (
  data: any,
  accessToken: string,
  options?: { timeoutMs?: number }
) => postImport(url.IMPORT_MDA, data, accessToken, options);
export const updateMda = (id: any, data: any) =>
  api.put(url.UPDATE_MDA + "/" + id, data);
export const deleteMda = (id: any) => api.delete(url.DELETE_MDA + "/" + id);
export const exportMdasToCsv = (params: any) =>
  api.get(url.EXPORT_MDAS_TO_CSV, params);
export const getMdaAgencies = (id: any) => {
  return api.get(url.GET_MDA_AGENCIES + "/" + id + "/agencies");
};
